import React from "react";
import CheckInPreset from "./CheckInPreset";

const CheckInScreen = () => {
  return <CheckInPreset />;
};

export default CheckInScreen;
